/**
 * Visibility status pill — live | hidden | scheduled | expired.
 * Used by ProductLibraryTable to surface storefront state per product.
 */
export const VisibilityBadge = ({ status, product }) => {
  const cfg = {
    live:      { bg: "bg-emerald-50",  text: "text-emerald-700",  label: "LIVE" },
    hidden:    { bg: "bg-slate-100",   text: "text-slate-500",    label: "HIDDEN" },
    scheduled: { bg: "bg-amber-50",    text: "text-amber-700",    label: "SCHEDULED" },
    expired:   { bg: "bg-rose-50",     text: "text-rose-700",     label: "ARCHIVED" },
  }[status] || { bg: "bg-slate-50", text: "text-slate-500", label: (status || "—").toUpperCase() };

  const detail =
    status === "scheduled" && product?.launch_at
      ? ` · ${new Date(product.launch_at).toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" })}`
      : status === "expired" && product?.archive_at
      ? ` · ${new Date(product.archive_at).toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" })}`
      : "";

  return (
    <span
      data-testid={`visibility-badge-${product?.id}`}
      className={`inline-block mt-1 text-[9px] font-accent tracking-wider px-1.5 py-0.5 ${cfg.bg} ${cfg.text}`}
    >
      {cfg.label}
      {detail}
    </span>
  );
};
